import {getCardInputs} from '../../../../../common/action-flows/helpers'
import {variableRegex} from '../../../../../common/card-assembler/resolvers'
import {CardDefinition} from '../../../../../common/types'

const htmlPlaceholder = ({
  id,
  type,
  label
}: {
  id: string
  type?: string
  label?: string
}) => {
  return `<span class="variable ${type ?? ''}" data-path="${id}" ${
    type ? `data-type="${type}"` : ''
  } contenteditable="false">${label ?? id}</span>`
}

export const makeNewPlaceholderElement = ({
  id,
  type,
  label
}: {
  id: string
  type?: string
  label?: string
}) => {
  const newVariable = document.createElement('span')
  newVariable.className = `variable ${type ? type : ''}`
  newVariable.setAttribute('data-path', id)
  if (type) {
    newVariable.setAttribute('data-type', type)
  }
  newVariable.setAttribute('contenteditable', 'false')
  newVariable.innerHTML = label ?? id

  return newVariable
}

// convert the editor's output into raw text content
export const serialiseVariables = (text: string) =>
  text.replace(
    // contenteditable inserts &nbsp; for us before and after the span, which
    // we don't want, so we detect and replace with a plain space here
    /(&nbsp;)?<span [^>]*?data-path="([^"]+)".*?>.*?<\/span>(&nbsp;)?/g,
    (_, spaceBefore: string, path: string, spaceAfter: string) => {
      return path === '__new'
        ? ''
        : `${spaceBefore ? ' ' : ''}%{${path}}${spaceAfter ? ' ' : ''}`
    }
  )

export type GetAttributes = (id: string) => {label?: string; type?: string}

// convert raw text content into html
// Note, the regexp used here should allow for both theme and card variables
export const variablesToHtml = (
  text: string,
  getAttributes?: GetAttributes
) => {
  const html = text.replace(variableRegex, (_, id: string) =>
    htmlPlaceholder({
      id,
      ...(getAttributes ? getAttributes(id) : {})
    })
  )
  return /<\/span>$/.test(html) ? `${html}&nbsp;` : html
  // the &nbsp; is to ensure the cursor can be placed after the last variable
}

let utilityDiv: HTMLDivElement

export const serialiseForEditor = (value: string, multiline = false) => {
  // serialise the raw value from the editor, with linebreaks preserved if
  // multiline, or stripped if not

  if (!utilityDiv) {
    // this div facilitates the conversion of div, br etc into \n
    // via innerText. It can't be display: none or it won't work
    utilityDiv = document.createElement('div')
    utilityDiv.style.position = 'absolute'
    utilityDiv.style.top = '-10000px'
    document.body.appendChild(utilityDiv)
  }

  utilityDiv.innerHTML = serialiseVariables(value)
  const plainTextValue = utilityDiv.innerText

  return multiline ? plainTextValue : plainTextValue.replace(/\n/g, '')
}

export const getCardInput = (definition: CardDefinition, key: string) => {
  return getCardInputs(definition as CardDefinition).find(
    input => input.key === key
  )
}
